<template>
  <modal name="offerBids" transition="pop-out" class="offerBidsPopup--wrapper">
    <div class="offerBidsPopup modal">
      <div>
        <div class="offerBids__table">
          <div class="offerBids__table-header">
            <div class="offerBids__table-cell offerBids__table-cell--date">Creation date</div>
            <div class="offerBids__table-cell">Flyer</div>
            <div class="offerBids__table-cell">Bid</div>
            <div class="offerBids__table-cell">Canceled by</div>
            <div class="offerBids__table-cell">Cancellation date</div>
            <div class="offerBids__table-cell">Is active</div>
          </div>
          <div class="offerBids__table-body js-customScroll">
            <vue-scroll :ops="ops" v-if="offerBidsList.length">
              <div v-for="insideItem of offerBidsList"
                   :key="insideItem.id"
                   class="offerBids__table-row"
                   @click="cancelBidClick(insideItem)"
              >
                <div class="offerBids__table-row-inner">
                  <div class="offerBids__table-row-header">
                    <div class="offerBids__table-cell offerBids__table-cell--date">
                      <div class="offerBids__table-cell__mobile">Creation date</div>
                      <div class="offerBids__table-cell__content">{{moment(insideItem.flightDepartureDate).format('M/D/YYYY')}}</div>
                    </div>
                    <div class="offerBids__table-cell">
                      <div class="offerBids__table-cell__mobile">Flyer</div>
                      <div class="offerBids__table-cell__content">{{ `${insideItem.flyer.lastName} ${insideItem.flyer.firstName}` }}</div>
                    </div>
                    <div class="offerBids__table-cell">
                      <div class="offerBids__table-cell__mobile">BID</div>
                      <div class="offerBids__table-cell__content">{{insideItem.bidValue.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}}</div>
                    </div>
                    <div class="offerBids__table-cell">
                      <div class="offerBids__table-cell__mobile">Canceled by</div>
                      <div class="offerBids__table-cell__content">{{insideItem.canceledBy != null ? `${insideItem.canceledBy.lastName} ${insideItem.canceledBy.firstName}` : ''}}</div>
                    </div>
                    <div class="offerBids__table-cell offerBids__table-cell--date">
                      <div class="offerBids__table-cell__mobile">Cancellation date</div>
                      <div class="offerBids__table-cell__content">{{insideItem.canceledOn && moment(insideItem.canceledOn).format('M/D/YYYY')}}</div>
                    </div>
                    <div class="offerBids__table-cell">
                      <div class="offerBids__table-cell__mobile">Is active</div>
                      <div class="offerBids__table-cell__content">{{ insideItem.isActive ? 'Yes' : 'No' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
            <div v-else class="emptyList">Nothing found</div>
          </div>
        </div>
      </div>
      <button type="button" class="modal__close" @click="this.hide">
        <SvgIcon name="close-white"/>
      </button>
    </div>
    <QuestionPopup
      :name="'QuestionPopupCancel'"
      :title="'The bid will be canceled'"
      :text="'Are you sure?'"
      @remove="cancelBid"
    />
  </modal>
</template>

<script>
import './OfferBidsPopup.styl'
import QuestionPopup from '@/components/common/modals/QuestionPopup'
import SvgIcon from '@/components/common/SvgIcon/SvgIcon'
import moment from 'moment'

export default {
  name: 'OfferBidsPopup',
  data: () => ({
    ops: {
      rail: {
        size: '3px',
      },
      bar: {
        size: '3px',
        background: 'rgba(0,0,0,0.1)',
      },
    },
    currentItem: null,
  }),
  computed: {
    offerBidsList () {
      return this.$store.state.exchangeOffers.offerBidsList
    },
  },
  methods: {
    moment,
    show () {
      this.$modal.show('offerBids')
    },
    hide () {
      this.$modal.hide('offerBids')
    },
    cancelBidClick (item) {
        this.currentItem = item;
        this.$modal.show('QuestionPopupCancel');
    },
    async cancelBid () {
        const res = await this.$store.dispatch('cancelBid', this.currentItem.id);
        console.log(res)
        await this.$store.dispatch('getBidsByOfferId', this.currentItem.offerId);
        this.currentItem = null;
        this.$modal.hide('QuestionPopupCancel')
    },
  },
  created () {
    this.$parent.$on('showModal', this.show)
  },
  components: {
    QuestionPopup,
    SvgIcon,
  },
}

</script>
